import React, { useMemo } from 'react';
import { Collapse } from 'antd';
import AdaptiveTable from './AdaptiveTable';
import {
  parseAgentMeasurementJson,
  type AgentMeasurementRow,
} from '../utils/agentMeasurementDisplay';

interface AgentMeasurementTableProps {
  json: string | null | undefined;
}

const columns = [
  { title: '箱号', dataIndex: 'cartonId', width: 160, ellipsis: true },
  { title: '长×宽×高(cm)', dataIndex: 'dimensions', width: 140 },
  { title: '体积(m³)', dataIndex: 'volume', width: 90 },
  { title: '体积重(kg)', dataIndex: 'volumeWeight', width: 100 },
  { title: '毛重(kg)', dataIndex: 'grossWeight', width: 90 },
  { title: '状态', dataIndex: 'statusText', width: 90 },
  { title: '限制', dataIndex: 'restrictText', width: 120, ellipsis: true },
  { title: '派送参考号', dataIndex: 'deliveryReference', width: 120, ellipsis: true },
];

/**
 * 代理测量数据表格 + 可折叠原始 JSON。
 */
const AgentMeasurementTable: React.FC<AgentMeasurementTableProps> = ({ json }) => {
  const parsed = useMemo(() => parseAgentMeasurementJson(json), [json]);

  if (!json?.trim()) {
    return <div style={{ color: '#999' }}>暂无测量数据</div>;
  }

  return (
    <div>
      {!parsed.ok && (
        <div style={{ color: '#ad6800', marginBottom: 8, fontSize: 12 }}>{parsed.error}</div>
      )}
      {parsed.ok && parsed.rows.length === 0 ? (
        <div style={{ color: '#999', marginBottom: 8 }}>暂无测量数据</div>
      ) : (
        <AdaptiveTable<AgentMeasurementRow>
          size="small"
          rowKey="key"
          pagination={false}
          scroll={{ x: 720, y: 280 }}
          dataSource={parsed.rows}
          columns={columns}
        />
      )}
      <Collapse
        ghost
        style={{ marginTop: 8 }}
        items={[
          {
            key: 'raw',
            label: '查看原始 JSON',
            children: (
              <pre
                style={{
                  margin: 0,
                  maxHeight: 200,
                  overflow: 'auto',
                  fontSize: 12,
                  whiteSpace: 'pre-wrap',
                  background: '#fafafa',
                  padding: 8,
                  borderRadius: 4,
                }}
              >
                {parsed.rawText || json}
              </pre>
            ),
          },
        ]}
      />
    </div>
  );
};

export default AgentMeasurementTable;
